import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { ApiError } from "../api/client";
import { listDevices, revokeDevice, type DeviceRow } from "../api/auth";

export function DevicesPage() {
  const { api } = useAuth();
  const [currentId, setCurrentId] = useState("");
  const [rows, setRows] = useState<DeviceRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  async function refresh() {
    try {
      const r = await listDevices(api);
      setCurrentId(r.current_device_id);
      setRows(r.devices);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "load failed");
    }
  }

  useEffect(() => { refresh(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  async function doRevoke(id: string) {
    if (!confirm("Revoke this device? Its next refresh attempt will fail.")) return;
    try {
      await revokeDevice(api, id);
      await refresh();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "revoke failed");
    }
  }

  return (
    <div className="vstack">
      <div>
        <h1>Devices</h1>
        <p className="meta">Each session issued by a login or device-code approval.</p>
      </div>

      <div className="card">
        <h2>Active</h2>
        {rows.filter((r) => !r.revoked_at).length === 0 && <p className="meta">No active devices.</p>}
        {rows.filter((r) => !r.revoked_at).map((r) => (
          <div className="row" key={r.id}>
            <div>
              <div className="row-title">
                {r.label}
                {r.id === currentId && <span className="subtle"> &nbsp;· this session</span>}
              </div>
              <div className="row-meta">
                {r.platform} · last seen {r.last_seen_at} · {r.last_ip ?? "no IP"}
              </div>
            </div>
            {r.id !== currentId && (
              <button className="btn danger" onClick={() => doRevoke(r.id)}>Revoke</button>
            )}
          </div>
        ))}
        {error && <div className="error">{error}</div>}
      </div>

      {rows.some((r) => r.revoked_at) && (
        <div className="card">
          <h2>Revoked</h2>
          {rows.filter((r) => r.revoked_at).map((r) => (
            <div className="row" key={r.id}>
              <div>
                <div className="row-title subtle">{r.label}</div>
                <div className="row-meta">revoked {r.revoked_at}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
